import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getDocumentosGenerales = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/docugeneral?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const getDocumentosGeneralesFiltro = async (exigeFecha, vigencia) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/docugeneral/filtro?empresa=${userInfo.empresa}&exigeFecha=${exigeFecha}&vigencia=${vigencia}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearDocuGeneral = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/docugeneral', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateDocuGeneral = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/docugeneral/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteDocuGeneral = (Id) => Axios.delete(`/docugeneral/${Id}`);
